export default "__VITE_ASSET__Dert4X0N__"